module.exports = __webpack_public_path__ + "static/media/logo-symbol.9fc63119.svg";